import getResponsiveClassname from './responsiveClassnames';
import getThemedClassname from './themedClassnames';

// returns classname(-mobile/-tablet)(-dark) based on theme, isMobile, isTablet
const getThemedResponsiveClassname = (className, isMobile, isTablet) => (
  getThemedClassname(getResponsiveClassname(className, isMobile, isTablet))
);

export default getThemedResponsiveClassname;
